import React from "react";
//#region redux
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { GeneralInfoStepProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { WizardSection } from "components/common/wintForms";
import GeneralDetailsSection from "./generalSection";
import CustomerAddressSection from "./addressSection";
import CustomerReferencePersonsSection from "./referenceSection";
import RutRotSettingsSection from "./rutRotSection";
import CustomerOtherDetailsSection from "./otherDetailsSection";
//#endregion

const GeneralInfoWizardStep: React.FC<GeneralInfoStepProps> = ({
  connect,
  submitted,
  wizardProps,
  customerId,
  isCreate,
  canToggleActiveStatus,
}) => {
  const generalInfoProps = connect("generalInfo");
  const rutRotSettingsProps = connect("rutRotSettings");
  const otherDetailsSettingsProps = connect("otherDetailsSettings");

  const nameProps = connect("generalInfo.name");

  return (
    <WizardSection
      header={TranslationKeys.Invoice.ClientDetails}
      description={nameProps.value}
      submitted={submitted}
      hasErrors={generalInfoProps.error || rutRotSettingsProps.error || otherDetailsSettingsProps.error}
      wizardProps={wizardProps}
    >
      <GeneralDetailsSection connect={connect} isCreate={isCreate} canToggleActiveStatus={canToggleActiveStatus} />
      <CustomerAddressSection connect={connect} />
      <CustomerReferencePersonsSection connect={connect} customerId={customerId} isCreate={isCreate} />
      <RutRotSettingsSection connect={connect} />
      <CustomerOtherDetailsSection connect={connect} />
    </WizardSection>
  );
};

export default GeneralInfoWizardStep;
